import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {
  ChcpShellUiModule,
  UndevelopedPageComponent,
} from '@cigna/chcp/shell/ui';
import { RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { ChcpClaimsSharedDataAccessModule } from '@cigna/chcp/claims/shared/data-access';
import { ChcpRoutes } from '@cigna/chcp/shared/util';
import { PageComponent } from './page/page.component';

const prop13Claim = 'pv-PS003-Claim Pages';
const routes: ChcpRoutes = [
  {
    path: '',
    component: PageComponent,
    children: [
      {
        path: '',
        redirectTo: 'search',
      },
      {
        path: 'search',
        loadChildren: () =>
          import('@cigna/chcp/claims/search-feature').then(
            (m) => m.ChcpClaimsSearchFeatureModule,
          ),

        data: {
          title: 'Claims Search',
          breadcrumb: 'search',
          // using 'trackPageLoadOnInit' in (libs/chcp/claims/search-feature/search-wrapper) to handle split rollout. uncomment here once legacy is retired
          // analytics: {
          //   name: 'My Claims',
          //   section: 'Claims',
          //   prop13: 'pv22496',
          //   eVar119: 'US1795876',
          // },
        },
      },
      {
        path: 'results',
        loadChildren: () =>
          import('@cigna/chcp/claims/results-feature').then(
            (m) => m.ChcpClaimsResultsFeatureModule,
          ),
        data: {
          title: 'Claim Search',
          breadcrumb: 'results',
          analytics: {
            name: 'Claim Search Results',
            section: 'Claims',
            prop13: prop13Claim,
          },
        },
      },
      {
        path: 'detail/:claimReferenceNumber',
        loadChildren: () =>
          import('@cigna/chcp/claims/details-feature').then(
            (m) => m.ChcpClaimsDetailsFeatureModule,
          ),
        data: {
          title: 'Claim Details',
          breadcrumb: 'details',
          analytics: {
            name: 'Claim Details',
            section: 'Claims',
            prop13: prop13Claim,
          },
        },
      },
      {
        path: 'multiplepatients',
        loadChildren: () =>
          import('@cigna/chcp/claims/multiple-patients-feature').then(
            (m) => m.ChcpClaimsMultiplePatientsFeatureModule,
          ),
        data: {
          title: 'Multiple Claims Results',
          breadcrumb: 'multiplepatients',
          analytics: {
            name: 'Claim Multiple Search Results',
            section: 'Claims',
            prop13: prop13Claim,
          },
        },
      },
      {
        path: 'coding-edit',
        loadChildren: () =>
          import('@cigna/chcp/claims/coding-edit-feature').then(
            (m) => m.ChcpClaimsCodingEditFeatureModule,
          ),
        data: {
          title: 'View Claim Coding Edits',
          analytics: {
            name: 'View Claim Coding Edits',
            section: 'Claims',
            prop13: 'pv-New Page',
          },
        },
      },
      {
        path: 'submit',
        component: UndevelopedPageComponent,
        data: {
          title: 'Submit a Claim',
          analytics: {
            name: 'Submit CLaim',
            section: 'Claims',
            prop13: 'pv-New Page',
          },
        },
      },
    ],
  },
];

@NgModule({
  imports: [
    CommonModule,
    ChcpShellUiModule,
    ChcpClaimsSharedDataAccessModule,
    RouterModule.forChild(routes),
    TranslateModule,
  ],
  declarations: [PageComponent],
})
export class ChcpClaimsShellFeatureModule {}
